import { render } from "./WrapWithPopover.vue?vue&type=template&id=57ed2730"
import script from "./WrapWithPopover.vue?vue&type=script&lang=js"
export * from "./WrapWithPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__